// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1EboJ","text":"SelectPayment_text__2jZon","title":"SelectPayment_title__2aT7A","btn":"SelectPayment_btn__1ZT7y"};